import request from './request';

const referralService = {
  getAll: (params) =>
    request.get('dashboard/admin/referrals/all', { params }),
  getById: (id) => request.get(`dashboard/admin/referrals/${id}`),
  create: (payload) =>
    request.post('dashboard/admin/referrals/list', payload),
  update: (id, payload) =>
    request.put(`dashboard/admin/referrals/update/${id}`, payload),
  deleteOne: (id) =>
    request.delete(`dashboard/admin/referrals/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/referrals/delete', { data: { ids } }),
};

export default referralService;
